import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import apiClient from '../utils/apiClient';
import TrendingCard from './TrendingCard';

const CategoryRow = ({ category, title }) => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await apiClient.get(`/trending/${category}`);
                setProducts(response.data.products || []);
            } catch (error) {
                console.error(`Error fetching products for ${category}:`, error);
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, [category]);

    if (loading) return (
        <section className="featured-section">
            <div className="section-header">
                <h2>Trending in {title}</h2>
            </div>
            <div className="loading-container">
                <div className="loading-spinner"></div>
                <p>Loading {title}...</p>
            </div>
        </section>
    );
    if (products.length === 0) return null;

    return (
        <section className="featured-section">
            <div className="section-header">
                <h2>Trending in {title}</h2>
                <Link to={`/products?category=${category}`} className="view-all-link">
                    View All <FiArrowRight />
                </Link>
            </div>
            <div className="trending-grid">
                {products.map((product) => (
                    <TrendingCard key={product.id} product={product} />
                ))}
            </div>
        </section>
    );
};

export default CategoryRow;
